module.exports = __webpack_public_path__ + "static/Planthouder-86731e62d416c1769df85d77de45d78d.jpg";